import { FiniteStateObservableFactory } from '../../../implementation';
import { GetSetSuperArgsFunction, IsFactoryClass, MakeFactory } from '../../../../../../classes/class-helpers/factory';
import { NotificationsObservableFactory } from '../../../../../core/notifications-observable/implementation';
import { GenerateFiniteStateObservableHookFromReadableStreamReaderWithPauseWorkflow } from './hook-generators';
import { BaseClass } from '../../../../../../classes/class-helpers/base-class';
import { ObservableFactory } from '../../../../../../core/observable/implementation';
import { IsFiniteStateObservableConstructor } from '../../../constructor';
import { ConstructFromReadableStreamObservable, IS_FROM_READABLE_STREAM_CONSTRUCTOR } from './constructor';
export function PureFromReadableStreamObservableFactory(superClass) {
    if (!IsFiniteStateObservableConstructor(superClass)) {
        throw new TypeError(`Expected FiniteStateObservableConstructor as superClass`);
    }
    const setSuperArgs = GetSetSuperArgsFunction(IsFactoryClass(superClass));
    return class FromReadableStreamObservable extends superClass {
        constructor(...args) {
            const [reader, options] = args[0];
            super(...setSuperArgs(args.slice(1), [
                GenerateFiniteStateObservableHookFromReadableStreamReaderWithPauseWorkflow(reader),
                options
            ]));
            ConstructFromReadableStreamObservable(this);
        }
    };
}
export let FromReadableStreamObservable;
export function FromReadableStreamObservableFactory(superClass) {
    return MakeFactory(PureFromReadableStreamObservableFactory, [], superClass, {
        name: 'FromReadableStreamObservable',
        instanceOf: FromReadableStreamObservable,
        waterMarks: [IS_FROM_READABLE_STREAM_CONSTRUCTOR],
    });
}
export function FromReadableStreamObservableBaseFactory(superClass) {
    return MakeFactory(PureFromReadableStreamObservableFactory, [FiniteStateObservableFactory, NotificationsObservableFactory, ObservableFactory], superClass, {
        name: 'FromReadableStreamObservable',
        instanceOf: FromReadableStreamObservable,
        waterMarks: [IS_FROM_READABLE_STREAM_CONSTRUCTOR],
    });
}
FromReadableStreamObservable = class FromReadableStreamObservable extends FromReadableStreamObservableBaseFactory(BaseClass) {
    constructor(reader, options) {
        super([reader, options], [], [], []);
    }
};
//# sourceMappingURL=implementation.js.map